package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.styles.SkillBarProgress
import org.gstechnovos.jexonplastech.util.Constants
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun SkillBar(
    name: String,
    index: Int,
    progressBarHeight: CSSSizeValue<CSSUnit.px> = 5.px,
    percentage: CSSSizeValue<CSSUnit.percent> = 50.percent,
    animatePercentage: Int
) {

    LocalBreakpoint.current

    Column(modifier = Modifier.fillMaxWidth().margin(5.px).maxWidth(500.px).padding(topBottom = 5.px)) {

        Row(
            modifier = Modifier.fillMaxWidth().margin(bottom = 5.px), horizontalArrangement = Arrangement.SpaceBetween
        ) {

            P(
                attrs = Modifier.margin(topBottom = 0.px).fontFamily(Constants.FONT_FAMILY).fontSize(20.px).fontWeight(
                    FontWeight.Normal
                ).color(Theme.Secondary.rgb).toAttrs()
            ) {
                Text(name)
            }

            P(
                attrs = Modifier.margin(topBottom = 0.px).fontFamily(Constants.FONT_FAMILY).fontSize(20.px).fontWeight(
                    FontWeight.Normal
                ).color(Theme.Secondary.rgb).toAttrs()
            ) {
                Text("${animatePercentage}%")
            }
        }

        Box(
            modifier = Modifier.fillMaxWidth().borderRadius(50.px) // 1. Apply Radius to the container of the bars
                .overflow(Overflow.Hidden)
        ) // 2. Clip the inner content so it respects the curve
        {
            Box(modifier = Modifier.fillMaxWidth().height(progressBarHeight).backgroundColor(Theme.Gray.rgb))


            Box(
                modifier = SkillBarProgress.toModifier().fillMaxWidth(percentage).height(progressBarHeight)
                    .backgroundColor(Theme.Primary.rgb).transition(
                        Transition.of(
                            property = "width",
                            duration = 1.s,             // Fixed duration for the animation itself
                            timingFunction = TransitionTimingFunction.EaseInOut,
                            delay = 200.ms * index      // Dynamic delay based on index
                        )
                    ),
            )
        }
    }
}